<button type="button" (click)="downloadWorkOrder('pdf')" class="btn btn-oclm">
  {{ 'BtnText.DownloadWO' | translate }}
  <img src="../../../../assets/image/add-icon.svg" class="add-icon" />
</button>
